import { createFileRoute } from '@tanstack/react-router';
import type { JSX } from 'react';

import { BrandingSettingsPage } from '@/areas/settings/manufacturing/OrganizationSettings/BrandingSettingsPage/BrandingSettingsPage';
import { canViewGeneralSettings } from '@/shared/permissions/pagePermissions';
import type { PageStaticData } from '@/shared/routing';

export const Route = createFileRoute('/_authenticated/settings/_menu/organization/branding')({
    staticData: {
        access: { permissions: canViewGeneralSettings },
        chrome: 'home',
    } satisfies PageStaticData,
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    return <BrandingSettingsPage />;
}
